"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TooltipContainer = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _reactTransitionGroup = require("react-transition-group");

var _styles = _interopRequireDefault(require("./styles"));

var _class, _class2, _temp;

var ARROW_PADDING = 12;
var transitionStyles = {
  entering: {
    opacity: '0',
    transition: 'all 300ms cubic-bezier(0.075, 0.82, 0.165, 1)'
  },
  entered: {
    opacity: '1',
    transition: 'all 300ms cubic-bezier(0.075, 0.82, 0.165, 1)'
  },
  exiting: {
    opacity: '0',
    transition: 'all 300ms cubic-bezier(0.075, 0.82, 0.165, 1)'
  }
};

var TooltipContainer = (0, _emotionTheming.withTheme)(_class = (_temp = _class2 =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TooltipContainer, _React$Component);

  function TooltipContainer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, TooltipContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(TooltipContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      contentVisible: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "toggleHandler", function (flag) {
      _this.setState({
        contentVisible: flag
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "childrenMountHandler", function (element) {
      _this.childrenElement = element;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "contentMountHandler", function (element) {
      if (element) {
        document.addEventListener('hover', _this.globalClickEventListener);
        var contentRect = element.getBoundingClientRect();

        var childrenRect = _this.childrenElement.getBoundingClientRect();

        var thresholdLeft = childrenRect.width / 2;
        var top = childrenRect.height / 2 + 50;
        var left;
        element.style.top = top + 'px';
        var windowWidth = window.innerWidth;

        if (contentRect.left > contentRect.width / 2 && windowWidth - contentRect.left > contentRect.width / 2) {
          left = (-contentRect.width - ARROW_PADDING) / 2.4 + thresholdLeft - 8;
          element.style.left = left + 'px';
        } else if (contentRect.right + thresholdLeft > windowWidth) {
          left = windowWidth - (contentRect.left + contentRect.width);
          element.style.left = left - 10 + 'px';
          element.lastElementChild.style.left = -left + thresholdLeft + 10 + 'px';
        } else {
          element.style.left = -contentRect.left + 10 + 'px';
          element.lastElementChild.style.left = contentRect.left + thresholdLeft - 10 + 'px';
        }
      } else {
        document.removeEventListener('hover', _this.globalClickEventListener);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "globalClickEventListener", function () {
      _this.setState({
        contentVisible: false
      });
    });
    return _this;
  }

  (0, _createClass2.default)(TooltipContainer, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          contentRenderer = _this$props.contentRenderer,
          children = _this$props.children,
          theme = _this$props.theme;
      var contentVisible = this.state.contentVisible;
      return _react.default.createElement("div", {
        className: _styles.default.root(),
        ref: this.childrenMountHandler
      }, children(this.toggleHandler), _react.default.createElement(_reactTransitionGroup.Transition, {
        timeout: 300,
        in: contentVisible
      }, function (state) {
        return state === 'exited' ? null : _react.default.createElement("div", {
          className: _styles.default.content(theme),
          ref: _this2.contentMountHandler,
          style: (0, _objectSpread2.default)({}, transitionStyles[state])
        }, _react.default.createElement("div", {
          "data-type": "main"
        }, contentRenderer()), _react.default.createElement("div", {
          "data-type": "arrow"
        }));
      }));
    }
  }]);
  return TooltipContainer;
}(_react.default.Component), (0, _defineProperty2.default)(_class2, "propTypes", {
  contentRenderer: _propTypes.default.func.isRequired,
  children: _propTypes.default.any.isRequired
}), _temp)) || _class;

exports.TooltipContainer = TooltipContainer;
var _default = TooltipContainer;
exports.default = _default;